<template>
  <a-modal title="操作" style="top: 20px;" :width="800" v-model="visible" :confirmLoading="confirmLoading"
    @ok="handleSubmit">
    <div v-if="judge == 1">
      <a-form :form="form">
        <a-form-item style="display:none">
          <a-input v-decorator="['storeId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机构名称" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-input v-model="storeName" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在省" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select @change="onChange" v-model="currentProvince">
            <a-select-option v-for="item in selectAllProvince2" :value="item.provinceCode">{{
                item.provinceName
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 所在市" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select v-model="currentCity">
            <a-select-option v-for="item in selectCityName" :value="item.cityCode">{{ item.cityName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务省" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select v-model="provinces" :size="size" style="width: 200px" @change="onChange2">
            <a-select-option v-for="i in selectAllProvince2" :key="i.provinceCode">
              {{ i.provinceName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务市" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select v-model="citys" :size="size" style="width: 200px" @change="onChange3">
            <a-select-option v-for="i in selectCityName2" :key="i.cityCode">
              {{ i.cityName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="可使用企业" style="position: relative">
          <span style="color: red;position: absolute;left: -92px;">*</span>
          <a-select v-model="organStoreEnterprises" :size="size" style="width: 200px" @change="handleChange">
            <a-select-option v-for="i in boxLis" :key="i.enterpriseId">
              {{ i.enterpriseName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机构负责人" style="position: relative">
          <span style="color: red;position: absolute;left: -92px;">*</span>
          <a-select v-model="storePersions" :size="size" style="width: 200px" @change="handleChange2">
            <a-select-option v-for="i in boxLis2" :key="i.userId">
              {{ i.userName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务类别" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-select v-model="serviceTypes" :size="size" style="width: 200px" @change="handleChange3">
            <a-select-option v-for="type in restaurantTypes" :key="type.code">
              {{ type.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算方式" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-select v-model="payment">
            <a-select-option value="0">先付款</a-select-option>
            <a-select-option value="1">后付款</a-select-option>
            <a-select-option value="2">配发</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-model="remark" maxlength="200" />
        </a-form-item>
      </a-form>
    </div>
    <div v-if="judge == 2">
      <a-form :form="form">
        <a-form-item style="display:none">
          <a-input v-decorator="['storeId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅仓库名称" style="position: relative">
          <span style="color: red;position: absolute;left: -105px;">*</span>
          <a-input v-model="storeName" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅手机号" style="position: relative">
          <span style="color: red;position: absolute;left: -92px;">*</span>
          <a-input maxLength="11" @change="onChange22" v-model="phone" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅姓名" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-input maxLength="11" @change="onChange22" v-model="masterName" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在省" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select @change="onChange" v-model="currentProvince">
            <a-select-option v-for="item in selectAllProvince2" :value="item.provinceCode">{{
                item.provinceName
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 所在市" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select v-model="currentCity">
            <a-select-option v-for="item in selectCityName" :value="item.cityCode">{{ item.cityName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务省" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select v-model="provinces" :size="size" style="width: 200px" @change="onChange2">
            <a-select-option v-for="i in selectAllProvince2" :key="i.provinceCode">
              {{ i.provinceName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务市" style="position: relative">
          <span style="color: red;position: absolute;left: -65px;">*</span>
          <a-select v-model="citys" :size="size" style="width: 200px" @change="onChange3">
            <a-select-option v-for="i in selectCityName2" :key="i.cityCode">
              {{ i.cityName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务类别" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-select v-model="serviceTypes" :size="size" style="width: 200px" @change="handleChange3">
            <a-select-option v-for="type in restaurantTypes" :key="type.code">
              {{ type.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算方式" style="position: relative">
          <span style="color: red;position: absolute;left: -78px;">*</span>
          <a-select v-model="payment">
            <a-select-option value="0">先付款</a-select-option>
            <a-select-option value="1">后付款</a-select-option>
            <a-select-option value="2">配发</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input v-model="remark" maxlength="200" />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import {
  editstore,
  system,
  getonestore,
  provinceCodeList,
  cityCodeList,
  saveStore,
  selectenterprise,
  selectuser,
  selectCityName,
  selectAllProvince,
  addsave,
  queryMasterByPhone
} from '@/api/accessory/store2'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'
export default {
  name: 'StoreModal',
  props: {},
  components: {},
  data() {
    return {
      storeId: '',
      masterName: '',
      serviceTypes: '',
      storePersions: '',
      organStoreEnterprises: '',
      citys: '',
      provinces: '',
      categoryId: '',
      userId: '',
      cityId: '',
      provinceId: '',
      // 结算方式
      payment: '',
      // 机构名称
      storeName: '',
      // 备注
      remark: '',
      // 师傅 市
      provinceCodes: '',
      // 师傅数据
      userNmae: '',
      // 手机号
      phone: '',
      // 师傅Id
      workerId: '',
      // 判断是否是师傅分库
      judge: '',
      // 市
      currentCity: '',
      // 省
      currentProvince: '',
      // 市
      selectCityName: '',
      selectCityName2: '',
      selectCityName3: '',
      // 省
      selectAllProvince: '',
      selectAllProvince2: '',
      judge33: '',
      // 所有师傅
      boxLis3: '',
      boxLis: '',
      boxLis2: '',
      boxLis4: '',
      size: 'default',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this)
    }
  },
  beforeCreate() { },
  async created() {
    selectAllProvince().then(res => {
      console.log(res)
      this.selectAllProvince2 = res.rows
      // this.selectAllProvince = res.rows
    })

    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.restaurantTypes.push({ code: key, label: value })
    })
  },
  methods: {
    onChange22(e) {
      console.log(e)
      if (this.phone.length == 11) {
        queryMasterByPhone({ phone: this.phone }).then(res => {
          console.log(res)
          if (res.data == null) {
            this.masterName = ''
            this.currentProvince = []
            this.currentCity = []
            this.provinces = []
            this.citys = []
            this.serviceTypes = []
          } else {
            this.masterName = res.data.masterName
          }

          this.masterId = res.data.masterId
          this.provinces = res.data.provinceCodes
          this.serviceTypes = res.data.installTypes
          this.citys = res.data.cityCodes
          provinceCodeList({ provinceCodeList: this.provinces.join(',') }).then(res => {
            console.log(res)
            let rows = res
            let result = []
            for (let i = 0; i < rows.length; i++) {
              console.log(rows[i])
              result = result.concat(rows[i])
            }
            this.selectCityName2 = result
            console.log(this.selectCityName2)
          })

          console.log(this.provinceCodes)
        })
        console.log(this.provinceCodes)
      }
      console.log(this.phone)
    },

    onChange(value) {
      console.log(value)
      this.currentCity = ''
      var provinceCode = value
      selectCityName({ provinceCode: provinceCode }).then(res => {
        console.log(res)
        this.selectCityName = res.rows
      })
    },

    onChange2(checkedValues) {
      this.citys = []
      console.log(checkedValues)
      this.provinceId = checkedValues
      this.provincialCity()
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },

    onChange3(checkedValues) {
      console.log('enterprise = ', checkedValues)
      var array1 = checkedValues
      this.cityId = array1
      this.modelAccessories = array1.slice()
      console.log(this.modelAccessories)
    },
    handleChange(value) {
      console.log(`Selected: ${value}`)
      var array1 = value
      this.enterpriseId = array1
      this.modelAccessories2 = array1.slice()
      console.log(this.modelAccessories2)
    },

    onChange5(checkedValues) {
      console.log('enterprise = ', checkedValues)
      var array1 = checkedValues
      this.modelAccessories5 = array1.slice()
      console.log(this.modelAccessories5)
    },

    handleChange2(value) {
      console.log(value)
      console.log(`Selected: ${value}`)
      var array1 = value
      this.userId = array1
      this.modelAccessories3 = array1.slice()
      console.log(this.modelAccessories3)
    },
    handleChange3(value) {
      console.log(`Selected: ${value}`)
      var array1 = value
      this.categoryId = array1
      this.modelAccessories4 = array1.slice()
      console.log(this.modelAccessories4)
    },
    // 机构新增
    add() {
      this.masterName = ''
      // 服务市
      this.citys = []
      // 服务省
      this.provinces = []
      // 可使用企业
      this.organStoreEnterprises = []
      // 机构负责人
      this.storePersions = []
      // 服务类别
      this.serviceTypes = []
      // 结算方式
      this.payment = ''
      // 机构名称
      this.storeName = ''
      // 备注
      this.remark = ''
      // 师傅 市
      this.provinceCodes = ''
      // 师傅数据
      this.userNmae = ''
      // 手机号
      this.phone = ''
      // 师傅Id
      this.workerId = ''
      // 判断是否是师傅分库
      this.judge = ''
      // 市
      this.currentCity = ''
      // 省
      this.currentProvince = ''
      // 市
      this.selectCityName = ''
      this.selectCityName2 = ''
      this.selectCityName3 = ''

      this.judge33 = ''
      // 所有师傅
      this.boxLis3 = ''
      this.boxLis = ''
      this.boxLis2 = ''
      this.boxLis4 = ''
      this.judge33 = 0
      this.judge = 1
      selectenterprise({}).then(res => {
        console.log(res)
        this.boxLis = res.rows
        console.log(this.boxLis)
        console.log(this.commonFlag)
      })
      selectuser({ roleId: 12 }).then(res => {
        console.log(res)
        this.boxLis2 = res.rows
        console.log(this.boxLis2)
        console.log(this.commonFlag)
      })
      this.form.resetFields()
      this.edit({ storeId: 0 })
    },
    // 师傅新增
    add2() {
      //  师傅姓名
      this.masterName = ''
      // 服务市
      this.citys = []
      // 服务省
      this.provinces = []
      // 可使用企业
      this.organStoreEnterprises = []
      // 机构负责人
      this.storePersions = []
      // 服务类别
      this.serviceTypes = []
      // 结算方式
      this.payment = ''
      // 机构名称
      this.storeName = ''
      // 备注
      this.remark = ''
      // 师傅 市
      this.provinceCodes = ''
      // 师傅数据
      this.userNmae = ''
      // 手机号
      this.phone = ''
      // 师傅Id
      this.workerId = ''
      // 判断是否是师傅分库
      this.judge = ''
      // 市
      this.currentCity = ''
      // 省
      this.currentProvince = ''
      // 市
      this.selectCityName = ''
      this.selectCityName2 = ''
      this.selectCityName3 = ''

      this.judge33 = ''
      // 所有师傅
      this.boxLis3 = ''
      this.boxLis = ''
      this.boxLis2 = ''
      this.boxLis4 = ''
      this.judge33 = 1
      this.judge = 2
      console.log('aaa')
      selectenterprise({}).then(res => {
        console.log(res)
        this.boxLis4 = res.rows
        console.log(this.boxLis4)
        console.log(this.commonFlag)
      })

      this.form.resetFields()
      this.edit({ storeId: 0 })
    },
    // 机构编辑和师傅编辑    
    edit(record) {
      if (record.forbiddenStatus == 1) {
        this.$message.error('已禁用')
      } else {
        if (this.judge33 == 0) {
          this.judge = 1
          selectuser({ roleId: 12 }).then(res => {
            console.log(res)
            this.boxLis2 = res.rows
            console.log(this.boxLis2)
            console.log(this.commonFlag)
          })
        } else {
          this.judge = 2
          // selectuser({ roleId: 11 }).then(res => {
          //   console.log(res)
          //   this.boxLis3 = res.rows
          //   console.log(this.boxLis3)
          //   console.log(this.commonFlag)
          // })
        }

        if (record.storeType == undefined) {
          this.judge = this.judge
        } else {
          if (record.storeType == 1) {
            this.judge = 1
          } else {
            this.judge = 2
          }
        }

        selectenterprise({}).then(res => {
          console.log(res)
          this.boxLis = res.rows
          console.log(this.boxLis)
          console.log(this.commonFlag)
        })

        this.storeId = record.storeId
        getonestore({ storeId: this.storeId }).then(res => {
          let that = this
          console.log(res)
          if (res.code == 0) {
            this.storeName = res.data.storeName
            this.currentCity = res.data.currentCity
            this.currentProvince = res.data.currentProvince
            if (res.data.currentProvince != null) {
              selectCityName({ provinceCode: res.data.currentProvince }).then(res => {
                console.log(res)
                this.selectCityName = res.rows
              })
            }
            this.provinces = res.data.provinces
            that.citys = res.data.citys
            this.modelAccessories = res.data.citys.join()
            if (res.data.provinces != null) {
              provinceCodeList({ provinceCodeList: this.provinces.join(',') }).then(res => {
                console.log(res)
                let rows = res
                let result = []
                for (let i = 0; i < rows.length; i++) {
                  console.log(rows[i])
                  result = result.concat(rows[i])
                }
                this.selectCityName2 = result
                console.log(this.selectCityName2)
              })
            }
            this.organStoreEnterprises = res.data.organStoreEnterprises
            this.modelAccessories2 = res.data.organStoreEnterprises.join()
            this.storePersions = res.data.storePersions
            this.modelAccessories3 = res.data.storePersions.join()
            this.serviceTypes = res.data.serviceTypes
            this.modelAccessories4 = res.data.serviceTypes.join()
            this.payment = res.data.payment
            this.remark = res.data.remark
            let workerId = res.data.workerId
            this.phone = res.data.phone
            // if(res.data.phone != null) {
            //   if(this.phone.length == 11) {
            //     queryMasterByPhone({ phone:this.phone }).then(res => {
            //       console.log(res)
            //       this.masterName = res.data.masterName
            //       this.masterId = res.data.masterId
            //       this.provinces = res.data.provinceCodes
            //       this.serviceTypes = res.data.installTypes
            //       this.citys = res.data.cityCodes
            //       provinceCodeList({ provinceCodeList: this.provinces.join(',') }).then(res => {
            //         console.log(res)
            //         let rows = res
            //         let result = []
            //         for (let i = 0; i < rows.length; i++) {
            //           console.log(rows[i])
            //           result = result.concat(rows[i])
            //         }
            //         this.selectCityName2 = result
            //         console.log(this.selectCityName2)
            //
            //       })
            //
            //       console.log(this.provinceCodes)
            //     })
            //     console.log(this.provinceCodes)
            //   }
            // }
            if (workerId != null) {
              system(workerId).then(res => {
                console.log(res)
                this.phone = res.phonenumber
                this.masterName = res.userName
              })
            }
          }
        })

        this.mdl = Object.assign(record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.mdl,
              'storeId',
              'storeName',
              'storeType',
              'workerId',
              'currentProvince',
              'currentCity',
              'currentArea',
              'payment',
              'delFlag',
              'forbiddenStatus',
              'createBy',
              'createTime',
              'updateBy',
              'updateTime'
            )
          )
        })
      }
    },
    handleSubmit(e) {
      // 师傅 this.judge == 2
      if (this.judge == 2) {
        if (this.validator()) {
          return
        } else {
          // 师傅编辑
          if (this.storeId != null && this.storeId != 0) {
            this.form.validateFields((err, values) => {
              const purchaseOrder = {
                currentCity: this.currentCity,
                currentProvince: this.currentProvince,
                // masterName: this.masterName,
                provinces: Array.isArray(this.provinces) ? this.provinces : [this.provinces],
                citys: Array.isArray(this.citys) ? this.citys : [this.citys],
                payment: this.payment,
                serviceTypes: Array.isArray(this.serviceTypes) ? this.serviceTypes : [this.serviceTypes],
                workerId: this.masterId,
                storeName: this.storeName,
                remark: this.remark,
                storeId: this.storeId,
                // citys: this.modelAccessories,
                // organStoreEnterprises: this.modelAccessories2,
                //serviceTypes: this.modelAccessories4,
                // storePersions: this.modelAccessories3,
                storeType: '2'
                // purchaseAccessories:dataSource2,
              }
              console.log(purchaseOrder)
              if (!err) {
                console.log('Received values of form: ', purchaseOrder)
                this.confirmLoading = true
                editstore(purchaseOrder)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message.success('保存成功')
                      //this.form.resetFields()
                      this.$emit('ok', 1)
                      this.visible = false
                    } else {
                      this.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    this.$message.error('系统错误，请稍后再试')
                  })
                  .finally(() => {
                    this.confirmLoading = false
                  })
              }
            })
          } else {
            // 师傅新增
            e.preventDefault()
            this.form.validateFields((err, values) => {
              const purchaseOrder = {
                currentCity: this.currentCity,
                currentProvince: this.currentProvince,
                // masterName: this.masterName,
                provinces: Array.isArray(this.provinces) ? this.provinces : [this.provinces],
                citys: Array.isArray(this.citys) ? this.citys : [this.citys],
                payment: this.payment,
                serviceTypes: Array.isArray(this.serviceTypes) ? this.serviceTypes : [this.serviceTypes],
                workerId: this.masterId,
                storeName: this.storeName,
                remark: this.remark,
                // citys: this.modelAccessories,
                // organStoreEnterprises: [this.modelAccessories2],
                //serviceTypes: this.modelAccessories4,
                // storePersions: this.modelAccessories3,
                storeType: '2'
                // purchaseAccessories:dataSource2,
              }
              console.log(purchaseOrder)
              if (!err) {
                console.log('Received values of form: ', purchaseOrder)
                this.confirmLoading = true
                addsave(purchaseOrder)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message.success('保存成功')
                      this.form.resetFields()
                      this.$emit('ok', 2)
                      this.visible = false
                    } else {
                      this.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    this.$message.error('系统错误，请稍后再试')
                  })
                  .finally(() => {
                    this.confirmLoading = false
                  })
              }
            })
          }
        }
      } else {
        // 机构 this.judge == 1
        if (this.validator()) {
          return
        } else {
          // 机构编辑
          if (this.storeId != null && this.storeId != 0) {
            this.form.validateFields((err, values) => {
              const purchaseOrder = {
                storeName: this.storeName,
                currentCity: this.currentCity,
                currentProvince: this.currentProvince,
                payment: this.payment,
                storeId: this.storeId,

                remark: this.remark,
                citys: [this.modelAccessories],
                organStoreEnterprises: [this.modelAccessories2],
                serviceTypes: [this.modelAccessories4],
                storePersions: [this.modelAccessories3],
                storeType: '1'
              }
              console.log(purchaseOrder)

              if (!err) {
                console.log('Received values of form: ', purchaseOrder)
                this.confirmLoading = true
                editstore(purchaseOrder)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message.success('保存成功')
                      this.form.resetFields()
                      this.$emit('ok', 1)
                      this.visible = false
                    } else {
                      this.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    this.$message.error('系统错误，请稍后再试')
                  })
                  .finally(() => {
                    this.confirmLoading = false
                  })
              }
            })
          } else {
            // 机构新增
            e.preventDefault()
            this.form.validateFields((err, values) => {
              const purchaseOrder = {
                storeName: this.storeName,
                currentCity: this.currentCity,
                currentProvince: this.currentProvince,
                payment: this.payment,
                storeId: this.storeId,

                remark: this.remark,
                citys: [this.modelAccessories],
                organStoreEnterprises: [this.modelAccessories2],
                serviceTypes: [this.modelAccessories4],
                storePersions: [this.modelAccessories3],
                storeType: '1'
                // purchaseAccessories:dataSource2,
              }
              console.log(purchaseOrder)
              if (!err) {
                console.log('Received values of form: ', purchaseOrder)
                this.confirmLoading = true
                addsave(purchaseOrder)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message.success('保存成功')
                      this.form.resetFields()
                      this.$emit('ok', 2)
                      this.visible = false
                    } else {
                      this.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    this.$message.error('系统错误，请稍后再试')
                  })
                  .finally(() => {
                    this.confirmLoading = false
                  })
              }
            })
          }
        }
      }
    },

    provincialCity() {
      provinceCodeList({ provinceCodeList: this.provinceId }).then(res => {
        // this.selectCityName2 = res
        let rows = res
        let result = []
        for (let i = 0; i < rows.length; i++) {
          console.log(rows[i])
          result = result.concat(rows[i])
        }
        this.selectCityName2 = result
        console.log(this.selectCityName2)
      })
    },

    validator() {
      if (this.storeName == '' || this.storeName == null || this.storeName == undefined) {
        this.$message.success('机构名称不能为空')
        return true
      }

      if (this.judge == 2) {
        if (this.phone == '' || this.phone == null || this.phone == undefined) {
          this.$message.success('号码不能为空')
          return true
        }
        if (this.masterName == '' || this.masterName == null || this.masterName == undefined) {
          this.$message.success('姓名不能为空')
          return true
        }
      } else {
        if (this.currentProvince == '' || this.currentProvince == null || this.currentProvince == undefined) {
          this.$message.success('所在省不能为空')
          return true
        }
        if (this.currentCity == '' || this.currentCity == null || this.currentCity == undefined) {
          this.$message.success('所在市不能为空')
          return true
        }
        if (
          this.organStoreEnterprises == '' ||
          this.organStoreEnterprises == null ||
          this.organStoreEnterprises == undefined
        ) {
          this.$message.success('可使用企业不能为空')
          return true
        }

        if (this.storePersions == '' || this.storePersions == null || this.storePersions == undefined) {
          this.$message.success('机构负责人不能为空')
          return true
        }
      }
      if (this.currentProvince == '' || this.currentProvince == null || this.currentProvince == undefined) {
        this.$message.success('所在省不能为空')
        return true
      }

      if (this.currentCity == '' || this.currentCity == null || this.currentCity == undefined) {
        this.$message.success('所在市不能为空')
        return true
      }
      if (this.provinces == '' || this.provinces == null || this.provinces == undefined) {
        this.$message.success('服务省不能为空')
        return true
      }
      if (this.citys == '' || this.citys == null || this.citys == undefined) {
        this.$message.success('服务市不能为空')
        return true
      }

      if (this.serviceTypes == '' || this.serviceTypes == null || this.serviceTypes == undefined) {
        this.$message.success('服务类别不能为空')
        return true
      }
      if (this.payment == '' || this.payment == null || this.payment == undefined) {
        this.$message.success('结算方式不能为空')
        return true
      }
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
